import { EnterprisePolicyResponse } from "@/api";
import { EnterprisePolicyPlatformCoverageRow } from "@/api/temp/EnterprisePoliciesService";

const enterprisePoliciesSeed: EnterprisePolicyResponse[] = [
  {
    id: "ent-pol-1042",
    name: "Embargoed Country Access Restriction",
    description: "Restrict access to embargoed geography datasets",
    status: "Active",
    enabled: true,
    lastModifiedDate: new Date("2026-08-06T09:20:00.000Z"),
  },
  {
    id: "ent-pol-1047",
    name: "US Customer Support Location Policy",
    description: "Limit support workflows to approved US locations",
    status: "Active",
    enabled: true,
    lastModifiedDate: new Date("2026-08-05T14:10:00.000Z"),
  },
  {
    id: "ent-pol-1051",
    name: "Customer Support Organization Hierarchy Access",
    description: "Apply organization hierarchy boundaries for support access",
    status: "Draft",
    enabled: false,
    lastModifiedDate: new Date("2026-08-03T10:45:00.000Z"),
  },
  {
    id: "ent-pol-1036",
    name: "Sensitive Customer Data Export Restriction",
    description: "Block exports containing sensitive customer identifiers",
    status: "Paused",
    enabled: false,
    lastModifiedDate: new Date("2026-07-30T17:05:00.000Z"),
  },
  {
    id: "ent-pol-1028",
    name: "Contractor Access Limitation",
    description: "Constrain contractor roles to scoped resources only",
    status: "Archived",
    enabled: false,
    lastModifiedDate: new Date("2026-07-07T11:30:00.000Z"),
  },
];

export const enterprisePolicyPlatformCoverageSeed: EnterprisePolicyPlatformCoverageRow[] =
  [
    {
      platform: "Snowflake Production",
      type: "Data platform",
      adoptionStatus: "Applied",
      owner: "Priya Nair",
    },
    {
      platform: "Snowflake Cortex Agent",
      type: "AI agent",
      adoptionStatus: "Pending Adoption",
      owner: "AI Platform Team",
    },
    {
      platform: "Foundry Support Agent",
      type: "AI agent",
      adoptionStatus: "Configuration Required",
      owner: "Support AI Team",
    },
    {
      platform: "Customer Support Portal",
      type: "Application",
      adoptionStatus: "Applied",
      owner: "Customer Apps",
    },
    {
      platform: "SharePoint",
      type: "Content platform",
      adoptionStatus: "Configuration Required",
      owner: "Collaboration Services",
    },
    {
      platform: "SAP HANA Finance",
      type: "Data platform",
      adoptionStatus: "Pending Adoption",
      owner: "Finance Platforms",
    },
    {
      platform: "Legacy Support Application",
      type: "Application",
      adoptionStatus: "Unsupported",
      owner: "Legacy Operations",
    },
  ];

export default enterprisePoliciesSeed;
